import { getLevelArrayMetric as r } from "../index4.js";
import { getLevelEfficiency as t } from "../level-metrics/index15.js";
const f = (e) => r(e, t);
export {
  f as getLevelArrayEfficiency
};
//# sourceMappingURL=index6.js.map
